import { EnvironmentProperty } from './environment.model';

export const environment: Partial<EnvironmentProperty> = {
  apiDomain: 'https://data-test3.hdw.hrsa.gov/HDWLocatorApi',
  isDevMode: true,
  production: false,
  baseHref: '/',
  analyticsId: 'GTM-MVDSQT',
  authToken: null
};
